/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNumeric = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-2 2H4v16h16zm-1.993 11.001v2h-12v-2zm-.563-7.737v.824l-1.376 1.408.188.028c.427.078.763.248 1.008.512.28.301.42.679.42 1.132 0 .4-.09.745-.272 1.036s-.441.513-.78.668-.74.232-1.204.232c-.304 0-.597-.03-.88-.092s-.533-.15-.752-.268V11.68l.17.083c.177.079.374.143.59.193.288.067.563.1.824.1.379 0 .67-.077.872-.232s.304-.376.304-.664c0-.272-.079-.483-.236-.632s-.388-.224-.692-.224c-.277 0-.55.05-.816.152L14.42 9.8l1.44-1.52H13.9V7.264zm-8.6 0V13H7.588V8.76l-1.328.448v-.736l1.696-1.208zm2.512-.104c.619 0 1.099.141 1.44.424s.512.685.512 1.208c0 .213-.043.427-.128.64s-.225.452-.42.716-.457.58-.788.948l-.808.888h2.16V13H9.54v-.84l1.456-1.6.162-.179c.206-.229.372-.421.498-.577.157-.195.268-.36.332-.496s.096-.263.096-.38c0-.485-.307-.728-.92-.728-.432 0-.923.147-1.472.44V7.568l.192-.09a3.796 3.796 0 0 1 1.472-.318z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNumeric as Numeric };
